import { render, staticRenderFns } from "./DownSort.vue?vue&type=template&id=1c4c3ff9&scoped=true&"
import script from "./DownSort.vue?vue&type=script&lang=js&"
export * from "./DownSort.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c4c3ff9",
  null
  
)

export default component.exports